import React from "react";
import { Button } from "antd";
import { ControlTwoTone, RollbackOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { getJumpingPath } from "utils/navigation";

const Title = styled.h1`
  font-size: 18px;
  margin: 0;
  span {
    margin-left: 8px;
  }
`;

const ToggleButton = styled(Button)`
  margin-left: 12px;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
`;

function HeaderContent() {
  const history = useHistory();
  const handleBackSite = React.useCallback(() => {
    history.push(getJumpingPath(""));
  }, [history]);
  return (
    <Title>
      <ControlTwoTone size={20} />
      <span>系统管理后台</span>
      <ToggleButton
        onClick={handleBackSite}
        type="dashed"
        icon={<RollbackOutlined />}
        size="small"
      >
        返回站点
      </ToggleButton>
    </Title>
  );
}

export default HeaderContent;
